import { useState } from 'react';
import { useGetProductsQuery } from './products.api';
import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';
import { ProductScope } from '@topshots/core-models';
import { ProductsTable } from './products-table';

export const Products = () => {
  const dispatch = useAppDispatch();
  const [scope, setScope] = useState<ProductScope | undefined>(undefined);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const [includeArchived, setIncludeArchived] = useState<boolean>(true);
  const [includeUnconfirmed, setIncludeUnconfirmed] = useState<boolean>(true);
  const { data, isLoading } = useGetProductsQuery({
    page,
    perPage,
    search,
    includeArchived,
    includeUnconfirmed,
    scope,
  });
  const navigate = useNavigate();

  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Products"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.PRODUCTS.title, link: Routes.PRODUCTS.link },
        ]}
        furtherActions={[
          { value: 'create', display: 'Create Product' },
          { value: 'selectors', display: 'Product Selectors' },
        ]}
        onAction={async (action) => {
          switch (action) {
            case 'create':
              dispatch(
                open({
                  title: 'Create Product',
                  contentKey: 'create-product',
                })
              );
              break;
            case 'selectors':
              navigate(Routes.PRODUCT_SELECTORS.link);
              break;
          }
        }}
      />
      <Card>
        <CardContent>
          <FilterBar
            //search={true}
            value={{
              scope: scope ?? '',
            }}
            filters={[
              {
                key: 'scope',
                title: 'Scope',
                options: [
                  { display: 'Any', value: '' },
                  { display: 'Image', value: ProductScope.Image },
                  { display: 'Event', value: ProductScope.Event },
                ],
                //default: OrderStatus.Confirmed,
              },
              // {
              //   key: 'includeArchived',
              //   title: 'Include Archived',
              //   options: [
              //     { display: 'Yes', value: 'true' },
              //     { display: 'No', value: 'false' },
              //   ],
              //   // default: 'true',
              // },

              // {
              //   key: 'includeUncomfirmed',
              //   title: 'Include Unconfirmed',
              //   options: [
              //     { display: 'Yes', value: 'true' },
              //     { display: 'No', value: 'false' },
              //   ],
              //   //default: OrderStatus.Confirmed,
              // },
            ]}
            onFilterChanged={(filter, values) => {
              switch (filter.key) {
                case 'scope':
                  if (values === '') {
                    setScope(undefined);
                  } else {
                    setScope(values as ProductScope);
                  }
                  break;
                // case 'includeArchived':
                //   if (values === 'true') {
                //     setIncludeArchived('true');
                //   } else {
                //     setIncludeArchived('false');
                //   }
                //   break;
                // case 'includeUnconfirmed':
                //   if (values === 'true') {
                //     setIncludeUnconfirmed('true');
                //   } else {
                //     setIncludeUnconfirmed('false');
                //   }
                //   break;
              }
            }}
            onSearch={(term) => {
              setSearch(term === '' ? undefined : term);
            }}
          />
        </CardContent>
        <ProductsTable
          data={data?.data ?? []}
          extraColumns={['confirmed', 'archived', 'public']}
          onClick={(p) => {
            navigate(`${p._id}`);
          }}
        />
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
